/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {

    export class CodeDropDownContext {
        public includeSpecifiedOptionsOnly: Array<string>;
        public removeSpecifiedOptions: Array<string>;
    }
}